import React from "react";
import Modal from "../components/Modal/Modal";
import styles from "./ErrorModal.module.scss";
import ErrorIllustration from "../icons/error-illustration.svg";
import { useTranslation } from "react-i18next";

const ErrorModal = () => {
  const { t } = useTranslation();

  return (
    <Modal name="error_modal" title={t("errorModal.title")} width="50vw">
      <div className={styles.content}>
        <img
          src={ErrorIllustration}
          alt={t("errorModal.illustrationAlt")}
          className={styles.illustration}
        />
        <div className={styles.text}>
          {t("errorModal.message")}
          <br />
          {t("errorModal.contact")}
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
